import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

import { useOS } from '@/app/hooks/useOS'
import { configService } from '@/app/services/configService'
import type { MobileAppVariant } from '@/app/config/mobileAppContent'

const isValidStoreUrl = (url?: string) =>
  !!url && url !== '#' && /^https?:\/\//.test(url)

export const useDownloadAppController = () => {
  const [searchParams] = useSearchParams()
  const variant: MobileAppVariant =
    searchParams.get('type') === 'admin' ? 'admin' : 'user'

  const { isIOS, isAndroid, isOther } = useOS()

  const {
    data: configsApp,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['configs'],
    queryFn: configService.getConfigsApp,
  })

  const storeLinks =
    variant === 'admin' ? configsApp?.admin_app : configsApp?.generic_app

  const appleUrl = isValidStoreUrl(storeLinks?.apple)
    ? storeLinks?.apple
    : undefined
  const googleUrl = isValidStoreUrl(storeLinks?.google)
    ? storeLinks?.google
    : undefined

  // Só redireciona se conseguimos identificar o SO E existe link válido para ele.
  const targetUrl = isIOS ? appleUrl : isAndroid ? googleUrl : undefined
  const isRedirecting = !isOther && !!targetUrl

  useEffect(() => {
    if (isLoading) return
    if (isRedirecting && targetUrl) {
      window.location.replace(targetUrl)
    }
  }, [isLoading, isRedirecting, targetUrl])

  return {
    appName: configsApp?.name,
    isLoading,
    isError,
    // enquanto carrega OU vai redirecionar, mostramos a tela de "abrindo a loja".
    isRedirecting: isLoading || isRedirecting,
    // No desktop (não é iOS nem Android) mostramos QR Codes para escanear com o celular.
    isDesktop: isOther,
    appleUrl,
    googleUrl,
  }
}
